import { connect } from 'react-redux';
import FileUpload from '../components/FileUpload';
import { loadSongData } from '../actions/song';

const jsonFileReader = file =>
  new Promise((accept, reject) => {
    if (file.type !== 'application/json') {
      reject(Error(`Invalid file type "${
        file.type
      }".  Only song files previously download from this app can be uploaded.`));
    }

    const reader = new FileReader();

    // inject an image with the src url
    reader.onload = (event) => {
      let j = {};
      try {
        j = JSON.parse(event.target.result);
      } catch (err) {
        reject(err);
      }
      accept(j);
    };

    // when the file is read it triggers the onload event above.
    reader.readAsText(file);

    return {};
  });

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  reader: jsonFileReader,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onUpload: (data) => {
    dispatch(loadSongData(data));
    ownProps.history.push('/');
  },
});

const SongUploadContainer = connect(mapStateToProps, mapDispatchToProps)(FileUpload);

export default SongUploadContainer;



// WEBPACK FOOTER //
// ./src/containers/SongUploadContainer.js